module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide",
    style: ({
      backgroundImage: 'url(' + _vm.background + ')'
    })
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h3', {
    staticClass: "heading",
    domProps: {
      "innerHTML": _vm._s(_vm.heading)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.subHeading)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_vm._v("Learn More")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab62b53a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeroSlider.vue
// module id = 83
// module chunks = 0